import React from "react";
import SystemHealth from "../../components/admin/SystemHealth";

/**
 * Standalone admin route for the system health dashboard.
 * Rendered at /admin/health behind the RequireAdmin guard.
 */
const SystemHealthPage = () => {
  return (
    <div className="space-y-4 sm:space-y-6">
      <SystemHealth />
    </div>
  );
};

export default SystemHealthPage;
